import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { withSignUp } from '../SignUpContext';
import { SignUpAskPhoneContent } from './SignUpAskPhoneContent';
import { PageContainer } from '../../../components/page-container/PageContainer';
import { Page } from '../../../components/page/Page';
import styles from './sign_up_ask_phone.module.scss';
import { SignUpLayout } from '../user/SignUpLayout';
import { Paper } from '../../../components/paper/Paper';

type Props = RouteComponentProps & {
  savePhoneNumber: Function;
  source: string;
  sourcePage: string;
};

export class RawSignUpAskPhone extends React.Component<Props> {
  saveAndGetToNextStep = (phoneNumber: string) => {
    this.props.savePhoneNumber(phoneNumber);
    const nextStepUrl = `/inscription/verification${window.location.search}`;
    this.props.history.push(nextStepUrl);
  };

  render() {
    return (
      <SignUpLayout>
        <PageContainer classNames="signup-card">
          <Page classNames={styles.container}>
            <Paper level={0} className="signup-card__container">
              <SignUpAskPhoneContent
                saveAndGetToNextStep={this.saveAndGetToNextStep}
                history={this.props.history}
                source={this.props.source}
                sourcePage={this.props.sourcePage}
              />
            </Paper>
          </Page>
        </PageContainer>
      </SignUpLayout>
    );
  }
}

export const SignUpAskPhone = withSignUp(RawSignUpAskPhone);
